import React, {Fragment, Suspense} from 'react';
import './assets/legacy.css';
import LegacyFrame from "./LegacyFrame";
import {getSessionValue} from "../../Common/Appcommon";

class Dashboard extends React.Component {

    render() {
        return (
            <LegacyFrame withHeader={true} pageTitle={"CRM"} formname={"table_16"} customClass={"field-customization-container"} customFrameClass={'dashboardheight'} />
        );
    } 
} 

export default Dashboard;
